import FranchisePage from './components/FranchisePage'

export default (store) => ({
  path: 'franchises',
  component: FranchisePage,
  indexRoute: {
    getComponent(nextState, cb) {
      import(
        /* webpackChunkName: 'Franchises' */
        './components/FranchiseList'
      ).then(module => {
        cb(null, module.default)
      })
    }
  },
  childRoutes: [
    {
      path: ':id/edit',
      getComponent(nextState, cb) {
        import(
          /* webpackChunkName: 'FranchiseForm' */
          './components/FranchiseForm'
        ).then(module => {
          cb(null, module.default)
        })
      }
    }
  ]
}) 